import React, { useState } from 'react';
import Button from '../Button';
import { StyledDeleteChatModal } from './DeleteProjectModal.style';
import projectService from '../../services/projectService';
import { useParams } from 'react-router-dom';
import Toast from '../Toast';

const DeleteThreadModal = ({ onClose, refetch, _id }) => {
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const handleSubmit = async () => {
    const payload = {
      project_id: id,
      session_id: _id,
    };
    setLoading(true);
    try {
      const resp = await projectService.deleteProjectSession(payload);
      console.log(resp);
      Toast({ type: 'success', message: resp?.detail });

      setLoading(false);
      refetch();
      onClose();
    } catch (error) {
      console.log(error);
      setLoading(false);
      Toast({ type: 'error', message: 'Something went wrong' });
    }
  };
  return (
    <StyledDeleteChatModal>
      <h2 className="desc">Are you sure you want to delete</h2>
      <div className="btn-holder">
        <Button width="136px" variant="secondary-outline" onClick={() => onClose()}>
          Cancel
        </Button>
        <Button width="150px" onClick={handleSubmit} loader={loading}>
          Delete
        </Button>
      </div>
    </StyledDeleteChatModal>
  );
};

export default DeleteThreadModal;
